import { PropsWithChildren } from 'react';
import { YbugProvider } from 'ybug-react';

import config from './../config';

type Props = PropsWithChildren;

export const YBugWrapper = ({ children }: Props) => {
  if (config.ybug.projectId) {
    return <YbugProvider ybugId={config.ybug.projectId}>{children}</YbugProvider>;
  } else {
    return children;
  }
};
